import type { IconSvgObject } from './types';

const NoodlesIcon: IconSvgObject = [
  ["path", { d: "M20.5 2L14 3.37879M4 5.5L6.5 4.9697M21 6L14 6.61765M4 7.5L6.5 7.27941", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 11.5004C18.5 10.1195 17.3807 9 16 9C14.6193 9 13.5 10.1195 13.5 11.5004", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.5 3.5V12M9 2.5V7.5M11.5 2V7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 19C6.61919 18.4256 3.06238 16.4871 3 12H21C20.9376 16.4871 17.3808 18.4256 16 19L16.576 20.6747C16.7993 21.3239 16.3169 22 15.6303 21.9999L8.38085 21.9996C7.69682 21.9995 7.21473 21.3281 7.43335 20.68L8 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default NoodlesIcon;
